/**
* @ngdoc filter
* @name sharebase.filter:sbSimpleDateTimeString
* @kind function
* 
* @description
*  Converts date time into a simple representation
*
* @param {string|number} datetime in string or ticks.
* 
*/
export function SimpleDateTimeStringFilter(gettextCatalog) {
	let lang = gettextCatalog.getCurrentLanguage();

	let useIntl = false;
	let dayFormatter;
	let weekFormatter;
	let monthFormatter;
	let yearFormatter;
	let timeStampFormatter;

	if ((window as any).Intl && (window as any).Intl.DateTimeFormat) {
		useIntl = true;
		// Intl.DateTimeFormat docs:
		// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat#Browser_compatibility
		// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toLocaleString#Performance

		// 3:30 PM for locales that use 12 hour
		// 15:30 for locales that use 24 hour
		dayFormatter = new Intl.DateTimeFormat(lang, {
			hour: '2-digit',
			minute: '2-digit'
		});

		// Mon 3:30 PM for locales that use 12 hour
		// Mon 15:30 for locales that use 24 hour
		weekFormatter = new Intl.DateTimeFormat(lang, {
			weekday: 'short',
			hour: 'numeric',
			minute: 'numeric'
		});

		// Jan 23, 2016
		yearFormatter = new Intl.DateTimeFormat(lang, {
			month: 'short',
			year: 'numeric',
			day: 'numeric'
		});

		// Sun, January 23, 2016, 3:30 PM 
		timeStampFormatter = new Intl.DateTimeFormat(lang, {
			weekday: 'short',
			year: 'numeric',
			month: 'long',
			day: 'numeric',
			hour: 'numeric',
			minute: 'numeric'
		});
	}
	else {
		dayFormatter = 'toLocaleTimeString';
		weekFormatter = 'toLocaleString';
		yearFormatter = 'toLocaleDateString';
		timeStampFormatter = 'toLocaleString';
	}		

	return function toSimpleString(val, fullTimeStamp = false) {
		let today = setDayOnly();
		let dateToFilter;
		let weekAgo = new Date();
		weekAgo.setDate(today.getDate() - 7);

		if (val == null) {
			return '';
		}
		else {
			dateToFilter = new Date(val);
		}

		if (dateToFilter) {
			let date = new Date(dateToFilter);
			date = setDayOnly(date);

			if (fullTimeStamp) {
				return useIntl ? timeStampFormatter.format(dateToFilter) : dateToFilter[timeStampFormatter]();
			}
			else if (sameDay(today, date)) {
				return useIntl ? dayFormatter.format(dateToFilter) : dateToFilter[dayFormatter]();
			}
			else if (date < today && date > weekAgo) {
				return useIntl ? weekFormatter.format(dateToFilter) : dateToFilter[weekFormatter]();
			}
			else  {
				return useIntl ? yearFormatter.format(dateToFilter) : dateToFilter[yearFormatter]();
			}
		}

		return val;

	};

	function sameDay(lhs, rhs) {
		return lhs.getMonth() === rhs.getMonth() &&
			lhs.getDate() === rhs.getDate() &&
			lhs.getFullYear() === rhs.getFullYear();
	}

	function setDayOnly(date = new Date()) {
		date.setHours(0);
		date.setMinutes(0);
		date.setSeconds(0);
		return date;
	}
}


SimpleDateTimeStringFilter.$inject = [
	'gettextCatalog'
];


// WEBPACK FOOTER //
// ./src/sharebase/filters/simpleDateTimeString.ts